module.exports = __webpack_public_path__ + "img/LV40003248087.e8dcd3ac.png";